import HeroSection from "@/components/home/HeroSection";
import MarqueeSection from "@/components/home/MarqueeSection";
import PhilosophySection from "@/components/home/PhilosophySection";
import DestinationsSection from "@/components/home/DestinationsSection";
import SignatureSection from "@/components/home/SignatureSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import FounderTeaser from "@/components/home/FounderTeaser";
import InquiryCTA from "@/components/home/InquiryCTA";
import useDestinations from "@/hooks/useDestinations";

export default function Home() {
  const destinations = useDestinations();

  return (
    <main className="bg-ivory text-ink overflow-x-hidden">
      <HeroSection />
      <MarqueeSection />
      <PhilosophySection />
      <DestinationsSection destinations={destinations} />
      <SignatureSection />
      <TestimonialsSection />
      <FounderTeaser />
      <InquiryCTA />
    </main>
  );
}
